import {Editor} from "../../../../../../pkg/slate.js";
const allMarks = ["bold", "underlined", "italic"];
export const removeFormatting = (editor) => allMarks.forEach((mark) => Editor.removeMark(editor, mark));
